import Constant from '@/const'
import Store from '@/store/index.js'
export default {
  namespaced: true,
  state: {
    MNG_NO: '',
    CAR_NAME: '',
    CAR_NO: '',
    TOUROKU_NO: '',
    HIKITORI_SAKI: '',
    NOUHIN_SAKI: '',
    LOGICO_MNG_NO: '',
    ORDER_DATE_FROM: '',
    ORDER_DATE_TO: '',
    HIKITORI_YOTEI_DATE_FROM: '',
    HIKITORI_YOTEI_DATE_TO: '',
    NOUSYA_YOTEI_DATE_FROM: '',
    NOUSYA_YOTEI_DATE_TO: '',
    YUSOU_SYUBETSU: [],
    STATUS: [],
    JYUCYU_SHIKI_CD: '',
  },
  mutations: {
    destroy(state) {
      state.MNG_NO = ''
      state.CAR_NAME = ''
      state.CAR_NO = ''
      state.TOUROKU_NO = ''
      state.HIKITORI_SAKI = ''
      state.NOUHIN_SAKI = ''
      state.LOGICO_MNG_NO = ''
      state.ORDER_DATE_FROM = ''
      state.ORDER_DATE_TO = ''
      state.HIKITORI_YOTEI_DATE_FROM = ''
      state.HIKITORI_YOTEI_DATE_TO = ''
      state.NOUSYA_YOTEI_DATE_FROM = ''
      state.NOUSYA_YOTEI_DATE_TO = ''
      state.YUSOU_SYUBETSU = []
      state.STATUS = []
      state.JYUCYU_SHIKI_CD = ''
    },
  },
  actions: {
    // 検索
    async search({ commit, dispatch }, data) {
      const request = {
        headers: {
          Authorization: `Bearer ${Store.state.auth.ACCESS_TOKEN}`,
          Accept: 'application/json',
        },
        params: data,
        url: Constant.API_URL.HISTORY,
        error: { message: '発注履歴の検索でエラーが発生しました。' },
      }
      return dispatch('http/get', { ...request }, { root: true })
        .then((res) => {
          return res
        })
        .catch((err) => {
          throw new Error(err.message)
        })
    },
    // 車両内訳取得
    async uchiwake({ commit, dispatch }, data) {
      const request = {
        headers: {
          Authorization: `Bearer ${Store.state.auth.ACCESS_TOKEN}`,
          Accept: 'application/json',
        },
        params: data,
        url: Constant.API_URL.HISTORY + '/uchiwake',
        error: { message: '車両料金内訳の取得でエラーが発生しました。' },
      }
      return dispatch('http/get', { ...request }, { root: true })
        .then((res) => {
          return res
        })
        .catch((err) => {
          throw new Error(err.message)
        })
    },
    // 車両画像取得
    async photos({ commit, dispatch }, data) {
      const request = {
        headers: {
          Authorization: `Bearer ${Store.state.auth.ACCESS_TOKEN}`,
          Accept: 'application/json',
        },
        params: data,
        url: Constant.API_URL.HISTORY + '/photos',
        error: { message: '車両画像の取得でエラーが発生しました。' },
      }
      return dispatch('http/get', { ...request }, { root: true })
        .then((res) => {
          return res
        })
        .catch((err) => {
          throw new Error(err.message)
        })
    },
    // キャンセル
    async cancel({ commit, dispatch }, data) {
      data.KEY = '1a08mvdg'
      const request = {
        params: data,
        url: Constant.HAKOBO_API_BASE_URL + 'delete_order.php',
        error: { message: '発注キャンセルの処理でエラーが発生しました。' },
      }
      return dispatch('http/post', { ...request }, { root: true })
        .then((res) => {
          return res
        })
        .catch((err) => {
          throw new Error(err.message)
        })
    },
    // 発注車両キャンセル
    async cancelJyucyuSyaryo({ commit, dispatch }, data) {
      const request = {
        headers: {
          Authorization: `Bearer ${Store.state.auth.ACCESS_TOKEN}`,
          Accept: 'application/json',
        },
        params: data,
        url: Constant.API_URL.HISTORY + '/cancel',
      }
      return dispatch('http/get', { ...request }, { root: true })
        .then((res) => {
          return res
        })
        .catch((err) => {
          throw new Error(err.message)
        })
    },
    // 発注履歴詳細
    async detail({ commit, dispatch }, data) {
      const request = {
        headers: {
          Authorization: `Bearer ${Store.state.auth.ACCESS_TOKEN}`,
          Accept: 'application/json',
        },
        params: data,
        url: Constant.API_URL.HISTORY + '/detail',
        error: { message: '対象車両のデータは存在しません。' },
      }
      return dispatch('http/get', { ...request }, { root: true })
        .then((res) => {
          return res
        })
        .catch((err) => {
          throw new Error(err.message)
        })
    },
    // ホーム画面発注履歴取得
    async getHistory({ commit, dispatch }, data) {
      const request = {
        headers: {
          Authorization: `Bearer ${Store.state.auth.ACCESS_TOKEN}`,
          Accept: 'application/json',
        },
        params: data,
        url: Constant.API_URL.HOME_HISTORY,
        error: { message: 'ホーム画面履歴取得に失敗しました。' },
      }
      return dispatch('http/post', { ...request }, { root: true })
        .then((res) => {
          return res
        })
        .catch((err) => {
          throw new Error(err.message)
        })
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/history.js